import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { Parceiro, ParceiroProvider, parceiroTheme } from './application/parceiro';

const setParceiro = (parceiro: Parceiro) => () => {
  document.getElementsByTagName('html')[0].setAttribute('data-theme', parceiroTheme[parceiro]);
  ParceiroProvider.set(parceiro);
  return true;
};

const routes: Routes = [
  {
    path: 'auto-login',
    loadChildren: () => import('./views/auth/auto-login/auto-login.module').then(m => m.AutoLoginModule)
  },
  {
    path: 'bnb',
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./bnb/views/bnb-main.module').then(m => m.BNBMainModule),
    canLoad: [setParceiro(Parceiro.BNB)],
    canActivate: [setParceiro(Parceiro.BNB)]
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./views/main.module').then(m => m.MainModule),
    pathMatch: 'prefix',
    canLoad: [setParceiro(Parceiro.BRASILCAP)],
    canActivate: [setParceiro(Parceiro.BRASILCAP)],

  },
  // {
  //   path: 'capfiador',
  //   runGuardsAndResolvers: 'always',
  //   loadChildren: () => import('./views/main.module').then(m => m.CapfiadorMainModule),
  //   canLoad: [setParceiro(Parceiro.CAPFIADOR)],
  //   canActivate: [setParceiro(Parceiro.CAPFIADOR)]
  // },
  {
    path: 'errors',
    children: [
      { path: 'not-found', loadChildren: () => import('./views/errors/not-found/not-found.module').then(m => m.NotFoundModule) },
      { path: 'unauthorized', loadChildren: () => import('./views/errors/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule) },
      { path: '', redirectTo: 'not-found', pathMatch: 'full' }
    ]
  },
  {
    path: '**',
    redirectTo: '/errors/not-found'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'corrected',
      preloadingStrategy: QuicklinkStrategy
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

